export default "__VITE_ASSET__X0p1jFqH__"